module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": require("../../assets/posters/velvetAshes.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Velvet Ashes")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016-2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional - Retreat Content")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Velvet Ashes is an online community of women serving overseas. They exist to connect the hearts of women who are separated by geography but bound together by the life of serving overseas.  It’s a place where we can link arms with one another and grab hold of the promise of Him who said, “I will give you a full life in the {seemingly} emptiest of places.” (Isaiah 58:11)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": require("../../assets/projects/velvet-ashes/velvetAshesTestimonial.jpg")
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Danielle Wheeler")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Founder of Velvet Ashes")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("With the help of Famous King, our ministry created an online retreat experience that touched over 1,000 women who are serving Jesus in 91 countries. These women received encouragement, community and renewal through the videos of this retreat experience, and were empowered for the kingdom work that God has called them to. Women described the retreat as an anchor for their souls, and are eagerly awaiting the next retreat!\n      "), _c('br'), _c('br'), _vm._v("Famous King’s videography has taken our ministry to a whole new level. With high quality videos, our network and support base has multiplied. The videographer is amazing to work with. He’s extremely talented at what he does and has huge heart to help our ministry. He enabled us to communicate our message in an artistic, professional way that people find deeply moving. We are constantly asked, “Wow, who does your videos?”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a5a8e11"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/projects/VelvetAshes.vue
// module id = 76
// module chunks = 0